import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { type FieldValues, type Path, useController } from "react-hook-form";
import { type ElementTracking, useElementTracking } from "../../../analytics/analytics";

export const CeFontSize = <TfieldValues extends FieldValues>({
  name,
  analyticsCategory,
}: {
  name: Path<TfieldValues>;
} & ElementTracking): React.JSX.Element => {
  const { field } = useController<TfieldValues>({ name });
  const analyticsProps = useElementTracking(analyticsCategory, name, "select");
  return (
    <FormControl fullWidth>
      <InputLabel id={`${name}-label`}>Font Size</InputLabel>

      <Select
        labelId={`${name}-label`}
        fullWidth
        value={field.value}
        label="Font Size"
        onChange={field.onChange}
        inputProps={{ "data-testid": name, ...analyticsProps }}
      >
        <MenuItem value={8}>8px</MenuItem>
        <MenuItem value={10}>10px</MenuItem>
        <MenuItem value={12}>12px</MenuItem>
        <MenuItem value={14}>14px</MenuItem>
        <MenuItem value={16}>16px</MenuItem>
        <MenuItem value={18}>18px</MenuItem>
        <MenuItem value={20}>20px</MenuItem>
        <MenuItem value={22}>22px</MenuItem>
        <MenuItem value={24}>24px</MenuItem>
        <MenuItem value={26}>26px</MenuItem>
      </Select>
    </FormControl>
  );
};
